<template>
  <v-container fluid grid-list-md id="page-body" :class="{'px-0': $vuetify.breakpoint.smAndDown}">
    <v-layout row>
      <v-flex xs12 sm6 md4>
        <rsscard newsSource="rennlist" className="rennlist card-with-image" displayThumb="true" :rssImage="`https://rennlist.com/assets/images/sites/rennlist.com/logo.svg?v=393812`"></rsscard>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <rsscard newsSource="flatsixes" className="flatsixes card-with-image" displayThumb="true" :rssImage="`http://users.feedblitz.com/0afb3761d26dbe53161b70d6a36660a5/Porsche_Logov2.png`"></rsscard>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <rsscard newsSource="porschenewsroom" className="porsche-news card-with-image" displayThumb="true" :rssImage="'https://files.porsche.com/filestore/image/multimedia/none/875d5e3d-6763-47fe-bc52-809142d53274/svg/d4c766d7-7761-11e7-99c7-0019999cd470/porsche-svg.svg'"></rsscard>
      </v-flex>
    </v-layout>
    
    <v-layout row>
      <v-flex xs12>
        <bookmarkcards :bookmarks="porsche4saleBookmarks" v-if="is_data_fetched"></bookmarkcards>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs12>
        <bookmarkcards :bookmarks="porschePartsBookmarks" v-if="is_data_fetched"></bookmarkcards>
      </v-flex>
    </v-layout>


    <v-layout row>
      <v-flex xs12 md6
          v-for="(item, idx) in dataList"
          :key="idx">
        <datacard class="car-log" :lists="item"></datacard>
      </v-flex>
    </v-layout>
    
  </v-container>
</template>

<script>
import dataApi from '../services/ApiService'

export default {
  name: 'Cars',
  data: () => ({
      loading: true,
      is_data_fetched: false,
      porsche4saleBookmarks: [],
      porschePartsBookmarks: [],
      dataList: []
    }),
    methods: {
      getDataFile() {
        dataApi.fetchDataFile ('porsche4sale-bookmarks.json')
        .then(response => {
          if (Object.keys(response).length) {
            this.porsche4saleBookmarks = response.bookmarkList
            this.is_data_fetched = true
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
        })

        dataApi.fetchDataFile ('porscheparts-bookmarks.json')
        .then(response => {
          if (Object.keys(response).length) {
            this.porschePartsBookmarks = response.bookmarkList
            this.is_data_fetched = true
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
        })
        dataApi.fetchDataFile ('carlog-data.json')
        .then(response => {
          if (Object.keys(response).length) {
            // eslint-disable-next-line no-console
            console.log(response.dataList)
            this.dataList = response.dataList
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
        })

      }
    },
    mounted () {
      this.getDataFile()
    }
  }
</script>

<style lang="scss">
  .bookmark-card-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }

  
  .car-log {
    .data-card {
      min-height: 250px;
    }

    .column-heading, .data-row {
        .label4, .val4 {
          text-align: right;
        }
    }

    .data-row-xs {
      .label4 , .val4 {
        text-align: left;
      }
    }
  }
</style>
